import { render, staticRenderFns } from "./InternalsDetail.vue?vue&type=template&id=2938e634"
import script from "./InternalsDetail.vue?vue&type=script&lang=js"
export * from "./InternalsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports